
(function() {
  var result = { translations: { "pl": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }}min", "hours": "{{ hours }} godz.", "hoursAndMinutes": "{{ hours }} godz. {{ minutes }} min", "days": "{{ days }} dni", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} godz.", "days": "{{ days }} dn.", "hoursAndMinutes": "{{ hours }} godz. {{ minutes }} min" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{amountNumberValue}} {{currencyCode}}", "phoneNumberWithExtension": "{{phoneNumber}}, rozsz. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "pl": "static-7.1127"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1127",
    "ar-eg": "static-7.1127",
    "bg": "static-7.1127",
    "bn": "static-7.1127",
    "ca-es": "static-7.1127",
    "cs": "static-7.1127",
    "da": "static-7.1127",
    "de": "static-7.1127",
    "el": "static-7.1127",
    "en-gb": "static-7.1127",
    "en": "static-7.1127",
    "es-mx": "static-7.1127",
    "es": "static-7.1127",
    "et": "static-7.1127",
    "fi": "static-7.1127",
    "fr-ca": "static-7.1127",
    "fr": "static-7.1127",
    "he-il": "static-7.1127",
    "hi": "static-7.1127",
    "hr": "static-7.1127",
    "hu": "static-7.1127",
    "id": "static-7.1127",
    "it": "static-7.1127",
    "ja": "static-7.1127",
    "ko": "static-7.1127",
    "lt": "static-7.1127",
    "ms": "static-7.1127",
    "nl": "static-7.1127",
    "no": "static-7.1127",
    "pl": "static-7.1127",
    "pt-br": "static-7.1127",
    "pt-pt": "static-7.1127",
    "ro": "static-7.1127",
    "ru": "static-7.1127",
    "sk": "static-7.1127",
    "sl": "static-7.1127",
    "sv": "static-7.1127",
    "th": "static-7.1127",
    "tl": "static-7.1127",
    "tr": "static-7.1127",
    "uk": "static-7.1127",
    "vi": "static-7.1127",
    "x-pseudo": "static-7.1127",
    "zh-cn": "static-7.1127",
    "zh-hk": "static-7.1127",
    "zh-tw": "static-7.1127"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:pl', {version: 'static-7.1127'}); }
})();


